import URI from 'urijs';

const pixelTesterAPIPrefix = accountName => `/${accountName}/tracking/test-events/test-link`;

export const pixelTesterApiFactory = ({ callGetApi }) => {
    return {
        getPixelTester: (accountName, apiQueryParams) => {
            const url = URI(pixelTesterAPIPrefix(accountName));
            url.addSearch(apiQueryParams);

            return callGetApi(url.toString());
        },
    };
};
